import {GoogleGenerativeAI} from "@google/generative-ai";

export function createConnection() {
  window.Buffer = window.Buffer || require("buffer").Buffer;

  return {
async ai(prompt){
  const genAI = new GoogleGenerativeAI(process.env.REACT_APP_GEMINI);
  const model = genAI.getGenerativeModel({model: "gemini-2.0-flash"});

return  await model.generateContent(prompt).catch(er=>{console.log(er)})





},
  thumb(canvas,id) {
      canvas.toBlob(blob => {
        const path = 'f_' + id + '.png';
        const myFile = new File([blob], path, {
          type: blob.type
      });
        const AWS_ACCESS_KEY_ID = '7b161be99ba96be249024385793cbd41';
        const AWS_SECRET_ACCESS_KEY = 'ed5c0f21dfeefff66dd3067ac6953a4d035fd87403e59c7676051a8c013ab4fb';
        const AWS_ENDPOINT= 'https://03436cc6cf076e96702ae26ca015c79e.r2.cloudflarestorage.com/vids';
        /*
          this.S3 = new S3Client({
            region: 'auto',
            endpoint: AWS_ENDPOINT,
            credentials: {
              accessKeyId: AWS_ACCESS_KEY_ID,
              secretAccessKey: AWS_SECRET_ACCESS_KEY,
            },
          });
          //https://03436cc6cf076e96702ae26ca015c79e.r2.cloudflarestm/vids

          /*
               const config = {
                 bucketName: 'vids',
                 region: 'auto',
                 accessKeyId: AWS_ACCESS_KEY_ID,
                 secretAccessKey: AWS_SECRET_ACCESS_KEY,
                 s3Url: AWS_ENDPOINT
               }
               S3FileUpload.uploadFile(myFile, config)
                 .then((data)=>{
                   console.log(data.location);
                 }ch((err)=>{
                 alert(err);
               })
               /*
                    const ReactS3Client = new S3(config);
                    ReactS3Client
                      .uploadFile(myFile, 'f_'+id+'.png')
                      .then(data => console.log(data))
                      .catch(err => le.error(err))
                    /*
                          getSignedUrl(
                            S3,
                            new PutObjectCommand({
                              Bucket: 'vids',
                              Key: path,
                            }),
                            {
                              expiresIn: 60 * 60 * 24 * 7, //                }
                          ).then((url) =>{
                            /*
                            console.log('url',url);
                            const response =  fetch(url, {
                              method: "PUT",
                              headers: {
                                "Content-Type": 'image/png'
                              },
                              body: myFile
                            });
                            response.json().then(f=>{

                              console.log(f);

                            })



                          })


                          */





        //const tt = this.r2Service.getS(path, myFile, 'image/png' );
        //console.log(tt);
        // @ts-ignore
        //this.restService.updateItem('sujet', this.sujet!.id, {thumb: 'https://vids.facereplays.com/f_' + this.sujet!.id.toString() + '.png'})



      });





    },
      getnue( data=null,method='GET') {
          const myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          myHeaders.append("Authorization", 'Bearer ' + localStorage.getItem('token'));
          myHeaders.append("Accept", "application/json");
          myHeaders.append("x-apikey",'today');
          return fetch(process.env.REACT_APP_api+'api/records/point',
              {
                  method: 'POST',
                  body: JSON.stringify(data),

                  headers: myHeaders
              }
          )
              .then(response => response.json())
      },
      getnu(node, data=null,method='GET') {

          const myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          myHeaders.append("x-apikey",'today');
          myHeaders.append("Authorization", 'Bearer ' + localStorage.getItem('token'));
          myHeaders.append("Accept", "application/json");
          if(!method || method == 'GET') return fetch(process.env.REACT_APP_api+'api/new/records/' + node ,
              {
                  method: method,

                  headers: myHeaders
              }
          ).then(response => response.json())
          return fetch(process.env.REACT_APP_api+'api/new/records/' + node ,
              {
                  method: method,
                  body: JSON.stringify(data),

                  headers: myHeaders
              }
          )
              .then(response => response.json())



      },
      async  update(node, id=false, data) {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", 'Bearer ' + localStorage.getItem('token'));
      myHeaders.append("Accept", "application/json");
          myHeaders.append("x-apikey",'yes');
          const ur = id ? 'api/records/' + node + '/' + id : 'api/records/' + node;

    return fetch(process.env.REACT_APP_api+ur,
        {
          method: "PUT",
          body: JSON.stringify(data),

        headers: myHeaders
        }
      )
        .then(response => response.json())



    },
    async register(data) {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Accept", "application/json");
      let response = await fetch(process.env.REACT_APP_api+'api/register',
        {
          method: "POST",
          body: JSON.stringify(data),
          headers: myHeaders
        }
      );
      return await response.json();

    },
    insert(node, data, c=0) {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", 'Bearer ' + localStorage.getItem('token'));
      myHeaders.append("Accept", "application/json");
    c==1 &&  myHeaders.append("x-apikey",'today');
        c==2 &&  myHeaders.append("x-apikey",'yes');
     return fetch(process.env.REACT_APP_api+'api/records/'+node,
        {
          method: "POST",
          body: JSON.stringify(data),
headers: myHeaders
        }
      ).then(response => response.json())



    },
    async getUser(){
      const h ={Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
      const url=process.env.REACT_APP_api+"api/users";
     return await fetch(url, {
        headers:h


      }).then(response=>response.json())
    }
    ,
    async getPromise(ob,filter) {
      try{
        return await fetch(process.env.REACT_APP_api+'api/records/'+ob+'?' + filter)
          .then(response => response.json()).catch(a=>console.log(a))

      }catch(e){
        return null;

      }




    },
    async  get_T0(ob,filter) {

      try{
        return await fetch('https://timesca.com/wp-json/wp/v2/'+ob+'?' + filter)
          .then(response => {
            const res=  response.json();

            return res;

          }).catch(a=>console.log(a))

      }catch(e){
        console.log(e)

      }

    },
    async  get_T(ob,filter) {

      try{
        return await fetch('https://timesca.com/wp-json/wp/v2/'+ob+'?' + filter)
          .then(response => {
            const res=  response.json();

            const total=response.headers.get('X-WP-Total') ?  Number(response.headers.get('X-WP-Total')) : 0;
            return {res:res,total:total};

          }).catch(a=>console.log(a))

      }catch(e){
        console.log(e)

      }

    },
    async  delete(obj,id) {
const bid='2';

      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", 'Bearer ' + localStorage.getItem('token'));
      myHeaders.append("Accept", "application/json");
      return fetch(process.env.REACT_APP_api+'api/records/'+obj+'/'+ id,
        {
          method: "DELETE",
          headers: myHeaders
        }
      ).then(response => response.json())

    },
    async  get(ob,filter) {

      try{
        return await fetch(process.env.REACT_APP_api+'api/records/'+ob+'?' + filter)
          .then(response => response.json()).catch(a=>console.log(a))

      }catch(e){
        return null;

      }

    },
      async  getNew(ob,filter) {

          try{
              return await fetch(process.env.REACT_APP_api+'api/new/records/'+ob+'?' + filter)
                  .then(response => response.json()).catch(a=>console.log(a))

          }catch(e){
              return null;

          }

      },
    connect(filter) {

return fetch(process.env.REACT_APP_api+'api/records/merop?' + filter)
        .then(response => response.json())



    },
    disconnect() {
      console.log('❌ Disconnected from');
    }
  };
}
